import { FC } from 'react';

import Skeleton from '@material-ui/lab/Skeleton';

const SkeletonLoader: FC = () => {
  return <Skeleton variant="rect" width="100%" height="100%" />;
};

export default SkeletonLoader;
